module.exports = __webpack_public_path__ + "static/img/home_hint.59d8aad9.png";